// extracted by mini-css-extract-plugin
export var footer = "v_c4";
export var footerTop = "v_c5";
export var footerTopQrcode = "v_c6";
export var footerTopQrcodeBox = "v_c7";
export var footerTopQrcodeBoxImg = "v_c8";
export var footerTopQrcodeText = "v_c9";
export var footerTopQrcodeTextHighlight = "v_db";
export var footerTopRight = "v_dc";
export var footerTopRightLogo = "v_dd";
export var footerTopRightDescription = "v_df";
export var footerTopRightAddress = "v_dg";
export var footerBottom = "v_dh";